import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadGeneralService {
  public readonly load = signal(false);
  public readonly useLottie = signal(false);
  public readonly showProgress = signal(false);
  public readonly progress = signal(0);

  public emitLoad(isLoading: boolean, useLottie = false, showProgress = false): void {
    this.useLottie.set(useLottie);
    this.showProgress.set(showProgress);
    this.load.set(isLoading);
    if (!isLoading) {
      this.showProgress.set(false);
      this.progress.set(0);
    }
  }

  public setProgress(value: number, show = true): void {
    this.showProgress.set(show);
    this.progress.set(Math.min(100, Math.max(0, value)));
  }
}
